import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id"];
import { useAxiosClient } from '../hooks';
import { sanitizeParams } from '../utils';
import useMutation from './useMutation';
/**
 * Hook to fetch a resource based on a method call (e.g., a button click or another event)
 *
 * @example
 * const { fetch, isLoading, data } = useFetchAppointmentById();
 *
 * // In a click handler or useEffect
 * const handleFetchAppointment = () => {
 *   fetch({ id: 'appointment-123' });
 * };
 *
 * // Or using the async version
 * const fetchAppointment = async () => {
 *   const appointment = await fetchAsync({ id: 'appointment-123' });
 *   console.log(appointment);
 * };
 */
export default function useFetchMutationById(variant, basePath, options) {
  const axiosClient = useAxiosClient();
  async function mutationFn(_ref) {
    let {
        id
      } = _ref,
      params = _objectWithoutPropertiesLoose(_ref, _excluded);
    const url = variant.replace('{basePath}', basePath).replace('{id}', id);
    const response = await axiosClient.get(url, {
      params: sanitizeParams(params)
    });
    return response.data;
  }
  const mutationResult = useMutation([], mutationFn, options);
  return _extends({}, mutationResult, {
    fetch: mutationResult.mutate,
    fetchAsync: mutationResult.mutateAsync
  });
}